import { render } from "./AllClinics.vue?vue&type=template&id=0a509fa3&scoped=true&lang=pug"
import script from "./AllClinics.vue?vue&type=script&lang=js"
export * from "./AllClinics.vue?vue&type=script&lang=js"

import "./AllClinics.vue?vue&type=style&index=0&id=0a509fa3&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a509fa3"]])

export default __exports__